import { isEqual } from "lodash";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import EngagementsRowsConnected from "./engagements/engagements_rows_connected";
import RolesRowsConnected from "./roles/roles_rows_connected";

const Pinned = ({ pinnedIds, setPinnedIds, type }) => {
  const [pinnedItems, setPinnedItems] = useState([]);

  const RowsComponent = {
    engagements: EngagementsRowsConnected,
    roles: RolesRowsConnected
  }[type];

  useEffect(() => {
    const missingPinned = pinnedIds.filter((id) => !pinnedItems.find((item) => item.id === id));
    const alreadyPinned = pinnedItems.filter((item) => pinnedIds.find((id) => item.id === id));

    Promise.allSettled([
      ...missingPinned.map((id) =>
        $.ajax({
          url: ApiRoute(`/api/${type}/${id}`),
          api_version: 2
        })
      ),
      ...alreadyPinned.map((item) => Promise.resolve(item))
    ]).then((responses) => {
      const newValues = responses.filter(({ value }) => value).map(({ value }) => value);
      setPinnedItems(newValues);
    });
  }, [pinnedIds]);

  // update pinned ids, in case id was in storage but activity was deleted
  useEffect(() => {
    const pinnedItemsIds = pinnedItems.map(({ id }) => id);
    if (!isEqual(pinnedItemsIds, pinnedIds)) {
      setPinnedIds(pinnedItemsIds);
    }
  }, [pinnedItems]);

  return <RowsComponent items={pinnedItems} />;
};

Pinned.propTypes = {
  type: PropTypes.oneOf(["engagements", "roles"]).isRequired,
  pinnedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  setPinnedIds: PropTypes.func.isRequired
};

export default Pinned;
